import { render, staticRenderFns } from "./ThreeYearsTrainingForm.vue?vue&type=template&id=4194b660&"
import script from "./ThreeYearsTrainingForm.vue?vue&type=script&lang=js&"
export * from "./ThreeYearsTrainingForm.vue?vue&type=script&lang=js&"
import style0 from "./ThreeYearsTrainingForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDatePicker,VForm,VRow})
